import { Link } from 'react-router-dom'
import LegalDocumentLayout from '../components/LegalDocumentLayout'
import { LEGAL, privacyMailto, PRIVACY_DELETE_SUBJECT } from '../config/legal'

const PrivacyPolicyPage = () => (
  <LegalDocumentLayout eyebrow="Legal" title="Política de Privacidade">
    <p className="text-gray-600 dark:text-gray-400 text-sm">
      Última atualização: {LEGAL.lastUpdated}
    </p>

    <p>
      Bem-vindo ao <strong className="text-gray-900 dark:text-white">{LEGAL.brand}</strong>. Esta Política
      de Privacidade descreve como tratamos dados pessoais ao oferecer nossa plataforma web de monitoramento
      de volume, aplicativo e serviços relacionados, em conformidade com a Lei nº 13.709/2018 (LGPD).
    </p>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        1. Controlador e contato
      </h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>
          <strong className="text-gray-900 dark:text-white">Controlador:</strong> {LEGAL.brand} —{' '}
          {LEGAL.location}
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Canal do titular e encarregado:</strong>{' '}
          <a href={`mailto:${LEGAL.privacyEmail}`} className="text-accent font-semibold hover:underline">
            {LEGAL.privacyEmail}
          </a>
        </li>
      </ul>
      <p className="mt-3">
        Use o e-mail acima para exercer seus direitos, tirar dúvidas ou solicitar exclusão de dados.
      </p>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        2. Dados que coletamos
      </h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>
          <strong className="text-gray-900 dark:text-white">Conta:</strong> nome, e-mail, senha (armazenada
          de forma criptografada pelo provedor de autenticação) e, se aplicável, foto/nome do login social
          (Google).
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Perfil:</strong> telefone e preferências de
          exibição (ex.: tema claro/escuro no navegador).
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Dispositivo e monitoramento:</strong> identificador
          do dispositivo, configurações (formato e dimensões do reservatório), status de conexão e leituras
          dos sensores (nível, volume e alertas).
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Pagamento e faturamento:</strong> CPF, endereço,
          telefone, e-mail e dados de cobrança necessários à contratação de planos ou compra de dispositivo.
          Dados completos de cartão são processados pelo gateway de pagamento (Asaas) e não são armazenados
          em nossos servidores.
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Suporte:</strong> nome, e-mail, assunto e conteúdo
          da mensagem enviada pelo formulário de contato.
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Técnicos:</strong> registros de acesso, endereço IP,
          data/hora e identificadores de sessão para segurança e prevenção a fraudes.
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        3. Finalidades e bases legais
      </h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>
          <strong className="text-gray-900 dark:text-white">Execução de contrato:</strong> criar e gerenciar
          sua conta, fornecer monitoramento, histórico, alertas e funcionalidades do plano contratado.
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Consentimento:</strong> envio de mensagens pelo
          formulário de contato e aceite expresso de termos no cadastro e checkout.
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Obrigação legal:</strong> emissão de cobranças,
          registros fiscais e atendimento a autoridades, quando aplicável.
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Legítimo interesse:</strong> segurança da
          plataforma, prevenção a fraudes, melhoria do serviço e comunicações operacionais (ex.: alertas de
          nível e avisos de renovação).
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        4. Compartilhamento com terceiros (operadores)
      </h2>
      <p className="mb-3">
        Compartilhamos dados apenas quando necessário para operar o serviço. Não vendemos dados pessoais para
        marketing.
      </p>
      <ul className="list-disc pl-5 space-y-2">
        <li>
          <strong className="text-gray-900 dark:text-white">Google Firebase:</strong> autenticação, banco de
          dados em tempo real e hospedagem de infraestrutura.
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Asaas:</strong> processamento de pagamentos
          (cartão, PIX e boleto), cadastro de cliente e cobranças recorrentes.
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">FormSubmit:</strong> encaminhamento de mensagens
          do formulário de contato para nosso e-mail de suporte.
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">ViaCEP:</strong> consulta de endereço a partir do
          CEP informado no checkout (apenas o CEP é enviado).
        </li>
        <li>
          <strong className="text-gray-900 dark:text-white">Google Fonts:</strong> carregamento de tipografia
          no site (pode envolver endereço IP ao servidor da Google).
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        5. Transferência internacional
      </h2>
      <p>
        Alguns provedores (Google/Firebase, FormSubmit) podem processar dados em servidores fora do Brasil.
        Adotamos medidas contratuais e técnicas compatíveis com a LGPD para proteger essas transferências.
      </p>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        6. Retenção e eliminação
      </h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>
          Dados da conta e do monitoramento: enquanto a conta estiver ativa e pelo período necessário para
          cumprir obrigações legais ou resolver disputas.
        </li>
        <li>
          Dados de pagamento e faturamento: conforme exigências fiscais e contratuais com o Asaas (em geral,
          por até 5 anos após a última transação, salvo prazo legal maior).
        </li>
        <li>
          Mensagens de suporte: pelo tempo necessário para atendimento e registro, em geral até 2 anos.
        </li>
        <li>
          Após solicitação de exclusão confirmada, eliminaremos ou anonimizaremos os dados, salvo quando a
          lei exigir retenção.
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        7. Seus direitos (Art. 18 da LGPD)
      </h2>
      <p className="mb-3">Você pode solicitar, a qualquer momento:</p>
      <ul className="list-disc pl-5 space-y-2 mb-4">
        <li>Confirmação do tratamento e acesso aos dados</li>
        <li>Correção de dados incompletos ou desatualizados</li>
        <li>Anonimização, bloqueio ou eliminação de dados desnecessários</li>
        <li>Portabilidade dos dados a outro fornecedor</li>
        <li>Informação sobre compartilhamento com terceiros</li>
        <li>Revogação do consentimento, quando o tratamento depender dele</li>
        <li>Oposição a tratamentos irregulares</li>
      </ul>
      <p>
        Envie sua solicitação para{' '}
        <a href={privacyMailto()} className="text-accent font-semibold hover:underline">
          {LEGAL.privacyEmail}
        </a>{' '}
        ou use a opção &quot;Solicitar exclusão de dados&quot; em{' '}
        <Link to="/account" className="text-accent font-semibold hover:underline">
          Minha conta
        </Link>
        . Responderemos em prazo razoável, conforme a LGPD.
      </p>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        8. Segurança
      </h2>
      <p>
        Adotamos medidas técnicas e organizacionais, incluindo autenticação, comunicação criptografada (HTTPS),
        regras de acesso no Firebase e processamento de pagamentos via gateway certificado (PCI-DSS pelo
        operador). Nenhum sistema é 100% inviolável; em caso de incidente relevante, comunicaremos os titulares
        e a ANPD quando exigido por lei.
      </p>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        9. Cookies e armazenamento local
      </h2>
      <p>
        Utilizamos armazenamento local do navegador (ex.: preferência de tema) e cookies essenciais de sessão
        dos provedores de autenticação. Não utilizamos cookies de publicidade ou rastreamento comportamental
        de terceiros para marketing.
      </p>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        10. Crianças e adolescentes
      </h2>
      <p>
        O serviço não se destina a menores de 18 anos. Se identificarmos cadastro indevido, excluiremos a conta
        e os dados associados.
      </p>
    </section>

    <section>
      <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-3">
        11. Alterações desta política
      </h2>
      <p>
        Podemos atualizar esta política para refletir mudanças legais ou no serviço. A data da última
        atualização será revisada no topo desta página. Alterações relevantes poderão ser comunicadas por
        e-mail ou aviso na plataforma.
      </p>
    </section>

    <p className="text-gray-600 dark:text-gray-400 text-sm border-t border-gray-200 dark:border-gray-700 pt-8">
      Consulte também os{' '}
      <Link to="/termos" className="text-accent font-semibold hover:underline">
        Termos de Uso
      </Link>
      . Para solicitar exclusão de dados:{' '}
      <a
        href={privacyMailto(PRIVACY_DELETE_SUBJECT, 'Olá,\n\nSolicito a exclusão dos meus dados pessoais vinculados à conta:\n\nE-mail da conta: \n\nMotivo (opcional): \n')}
        className="text-accent font-semibold hover:underline"
      >
        {LEGAL.privacyEmail}
      </a>
    </p>
  </LegalDocumentLayout>
)

export default PrivacyPolicyPage
